import { Visibility, VisibilityOff, Info as InfoIcon, PlayCircleOutline as PlayIcon } from "@mui/icons-material";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import FONTS_FAMILY from '../../../theme/FontsFamily';
import {
    Box,
    Button,
    Container,
    Grid,
    IconButton,
    InputAdornment,
    MobileStepper,
    Step,
    StepLabel,
    Stepper,
    Typography,
    useMediaQuery,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import { useFormik } from "formik";
import parse from "html-react-parser";
import { useSnackbar } from "notistack";
import React, { Fragment, useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import CheckBox from "../../../components/CheckBox/CheckBox";
import PhoneTextField from "../../../components/PhoneTextField/PhoneTextField";
import Select from "../../../components/Select/Select";
import TextField from "../../../components/TextField/TextField";
import UploadFile from "../../../components/UploadFile/UploadFile";
import { HideGlobalLoading, ShowGlobalLoading } from "../../../redux/actions/UiActions";
import apiCall from "../../../services/ApiServerCall";
import wpCall from "../../../services/WpServerCall";
import COLORS from "../../../theme/Colors";
import {
    BodyText,
    MediumHeightDivider,
    SmallHeightDivider,
    StyledButton,
    StyledButtonOutlined,
    StyledCheckCircleIcon,
    SubTitle,
    Title,
    WpRichTextContainer,
} from "../../../theme/Styles";
import { FormSchemaCompany, RegisterCompanySteps } from "./RegisterConstants";
import { ButtonContainer, ButtonsContainer, DisclaimerSubTitle, DisclaimerTitle, FinalStepContainer,DisclaimerButtonCotainer } from "./styles/RegisterStyles";
import FormModal from "../../../components/FormModal/FormModal";
import TextInformation from "../../../components/TextInformation/TextInformation";
import { CenterContainer, DisclaimerContainer } from "../../Home/components/Footer/styles/FooterStyles";

export default function FormRegisterCompany({ setTab, setIsRegistered }) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const history = useHistory();
    const formTopRef = useRef(null);

    const matchesWidth = useMediaQuery("(min-width:768px)");
    const stepsTitles = RegisterCompanySteps.map((step) => step.title);
    const stepsLenght = RegisterCompanySteps.length;
    const [activeStep, setActiveStep] = useState(0);
    const lastStep = stepsLenght - 1 === activeStep;

    useEffect(() => {
        if (formTopRef.current) {
            const yOffset = -80;
            const y = formTopRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    }, [activeStep]);
    
    const [schemaValidation, setSchemaValidation] = useState({});
    const [userRegistered, setUserRegistered] = useState(false);
    const [questionsData, setQuestionsData] = useState([]);
    const [wordpressContent, setWordpressContent] = useState();
    const [isValidatingCedula, setIsValidatingCedula] = useState(false);
    const [isValidated, setIsValidated] = useState(false);
    const [isValidatingEmail, setIsValidatingEmail] = useState(false);
    const [isValidatingPhone, setIsValidatingPhone] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showRepeatedPassword, setShowRepeatedPassword] = useState(false);
    const [showRegisterDisclaimer, setShowRegisterDisclaimer] = useState(true);
    const [disclaimerOption, setDisclaimerOption] = useState("");

    const getRegisterQuestionsData = async () => {
        try {
            let questionsData = await apiCall().get("/auth/get/getquestionandanswer");
            if (questionsData) {
                setQuestionsData(
                    questionsData.data.payload?.map((question) => ({
                        value: question.id,
                        label: question.questions,
                    }))
                );
            }
        } catch (error) {}
    };

    const getAndSetAllWordPressContent = async () => {
        let data = await wpCall().get("/pages/v1/page/terminos-y-condiciones");
        setWordpressContent(data?.data?.content);
    };

    useEffect(() => {
        getRegisterQuestionsData();
        getAndSetAllWordPressContent();
    }, []);

    useEffect(() => {
        const innerSchema = FormSchemaCompany({
            setIsValidatingCedula,
            isValidatingEmail,
            setIsValidatingEmail,
            isValidated,
            setIsValidated,
            isValidatingPhone,
            setIsValidatingPhone,
        })[activeStep];
        if (typeof innerSchema === "object") {
            setSchemaValidation(innerSchema.validations);
        }
        return () => {};
    }, [activeStep, isValidated, isValidatingEmail]);

    const handleClickShowPassword = () => setShowPassword(!showPassword);
    const handleClickShowRepeatedPassword = () => setShowRepeatedPassword(!showRepeatedPassword);

    const formik = useFormik({
        initialValues: {
            is_company: "1",
            email: "",
            emailConfirmation: "",
            password: "",
            password_confirmation: "",
            document_type: "3",
            citizen_id: "",
            name: "",
            phone: "",
            razonsocial: "",
            extension: "",
            docMercantil: {
                files: [],
            },
            docNotorial: {
                files: [],
            },
            docCitizenID: {
                files: [],
            },
            first_citizen_question: "",
            first_citizen_answer: "",
            second_citizen_question: "",
            second_citizen_answer: "",
            third_citizen_question: "",
            third_citizen_answer: "",
            termsAndCondition: false,
        },
        validationSchema: schemaValidation,
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: (values, actions) => {
            validateStepForm({ values, actions });
        },
    });

    const handleStepsValidation = (step) => {
        if (RegisterCompanySteps[step]) {
            let stepElementError = false;
            for (let i = 0; i < RegisterCompanySteps[step].elements?.length; i++) {
                const element = RegisterCompanySteps[step].elements[i];
                if (formik.touched[element] && Boolean(formik.errors[element])) {
                    stepElementError = true;
                }
            }
            if (stepElementError) {
                return true;
            } else {
                return false;
            }
        }
    };

    const handleNext = () => {
        setActiveStep((prevActiveStep) => (prevActiveStep + 1 === stepsLenght ? prevActiveStep : prevActiveStep + 1));
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => (prevActiveStep === 0 ? 1 : prevActiveStep - 1));
    };

    const handleFieldsValidations = (errors) => {
        let fieldsKeys = Object.keys(errors);
        for (let i = 0; i < fieldsKeys.length; i++) {
            let error = errors[fieldsKeys[i]];
            formik.setFieldError(fieldsKeys[i], error[0]);
        }
    };

    const validateStepForm = ({ values, actions }) => {
        if (lastStep) {
            handleRegister(values);
        } else {
            setActiveStep(activeStep + 1);
            actions?.setTouched({});
            actions?.setSubmitting(false);
        }
    };

    const handleSubmitForm = (e) => {
        let nextStepErrorHasAnError;
        Object.keys(formik.errors).forEach((item) => {
            if (RegisterCompanySteps[activeStep + 1]?.elements?.includes(item)) {
                nextStepErrorHasAnError = true;
            }
        });
        window.scrollTo(0, 0);
        if (Object.keys(formik.errors).length !== 0 && !nextStepErrorHasAnError) {
            enqueueSnackbar("Llene todos los campos requeridos", { variant: "error" });
            return;
        } else {
            formik.handleSubmit(e);
        }
    };

    const questionsForShow = (questionNumber) => {
        //questionNumber == 0,1,2
        let selectedOptions = [
            formik.values.first_citizen_question,
            formik.values.second_citizen_question,
            formik.values.third_citizen_question,
        ];
        let optionsForRemove = selectedOptions.filter((option, index) => index !== questionNumber);
        return questionsData.filter((question) => !optionsForRemove.includes(question.value + ""));
    };

    const handleSecurityQuestionChange = (e) => {
        formik.setFieldValue(e.target.id, e.target.value);
    };

    const handleRegister = async (formData) => {
        dispatch(ShowGlobalLoading("Cargando"));
        try {
            const fData = new FormData();
            fData.append("registromercant", formData.docMercantil.files[0]);

            if(formData.docNotorial.files.length > 0){
                fData.append("podernotarizado", formData.docNotorial.files[0]);
            }
            
            fData.append("cedulaperaut", formData.docCitizenID.files[0]);

            await apiCall()
                .post("/auth/convert/mitur/company/files/to/base64", fData)
                .then(async (res) => {
                    if (res.data?.success) {
                        await apiCall()
                            .post("/auth/register/portal", {
                                is_company: formData.is_company,
                                document_type: formData.document_type,
                                rnc: formData.citizen_id,
                                email: formData.email,
                                nombre: formData.name,
                                razonsocial: formData.razonsocial,
                                extension: formData.extension,
                                password: formData.password,
                                password_confirmation: formData.password_confirmation,
                                telefono: formData.phone,
                                company_files: res.data.payload,
                            })
                            .then(async (res) => {
                                if (res.data?.success) {
                                    await apiCall().post("/auth/register/questionandanswer", [
                                        {
                                            citizen_question: formData.first_citizen_question,
                                            citizen_answer: formData.first_citizen_answer,
                                            citizen_id: formData.citizen_id,
                                        },
                                        {
                                            citizen_question: formData.second_citizen_question,
                                            citizen_answer: formData.second_citizen_answer,
                                            citizen_id: formData.citizen_id,
                                        },
                                        {
                                            citizen_question: formData.third_citizen_question,
                                            citizen_answer: formData.third_citizen_answer,
                                            citizen_id: formData.citizen_id,
                                        },
                                    ]);
                                    setUserRegistered(true);
                                    if (setIsRegistered) setIsRegistered(true);
                                } else {
                                    //handle errors from server
                                    if (typeof res.data?.msg?.error === "object") {
                                        handleFieldsValidations(res.data?.msg?.error);
                                        enqueueSnackbar(
                                            "Hay uno o mas errores con la información introducida. Valídalos e inténtalo nuevamente",
                                            {
                                                variant: "error",
                                            }
                                        );
                                        window.scrollTo(0, 0);
                                    } else {
                                        enqueueSnackbar("Ha sucedido un error inténtelo mas tarde o contacte a soporte", {
                                            variant: "error",
                                        });
                                        window.scrollTo(0, 0);
                                    }
                                }
                            });
                    }
                });
        } catch (error) {
            //handle local/network errors
        }
        dispatch(HideGlobalLoading());
    };
    // Lógica para validar solo al perder el foco (onBlur)
    const handleBlur = async (event) => {
        const field = event.target.id;
        await formik.validateField(field); // Valida solo el campo `email`
        formik.setFieldTouched(field, true); // Marca el campo como tocado
    };

    const handleDisclaimerContinue = () => {
        if (!disclaimerOption) {
            enqueueSnackbar("Por favor seleccione una opción para continuar", { variant: "warning" });
            return;
        }

        if (disclaimerOption === "owner") {
            setTab("1"); // Cambiar a Registro ciudadano
            setShowRegisterDisclaimer(false);
        } else {
            setShowRegisterDisclaimer(false); // Continuar con Registro empresa
        }
    };

    if (userRegistered) {
        return (
            <Container ref={formTopRef}>
                <Box
                    sx={{
                        textAlign: 'center',
                        py: 5,
                        px: { xs: 2, sm: 4 },
                        maxWidth: 580,
                        mx: 'auto'
                    }}
                >
                    <Box
                        sx={{
                            width: 84,
                            height: 84,
                            borderRadius: '50%',
                            bgcolor: 'rgba(16, 185, 129, 0.1)',
                            color: '#10B981',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mx: 'auto',
                            mb: 3
                        }}
                    >
                        <CheckCircleOutlineIcon sx={{ fontSize: 52 }} />
                    </Box>

                    <span className="uctt-eyebrow no-dash" style={{ color: '#0B8296', marginBottom: '8px' }}>
                        Registro de Empresa Solicitado
                    </span>

                    <Typography
                        variant="h1"
                        sx={{
                            fontFamily: 'Merriweather, Georgia, serif',
                            fontSize: { xs: '24px', sm: '28px' },
                            fontWeight: 700,
                            color: '#0F2350',
                            mt: 1,
                            mb: 2
                        }}
                    >
                        ¡Revisa tu correo electrónico!
                    </Typography>

                    <Typography
                        sx={{
                            fontFamily: FONTS_FAMILY.regular.body,
                            fontSize: '15px',
                            color: '#57697F',
                            lineHeight: 1.6,
                            mb: 4
                        }}
                    >
                        Hemos recibido la solicitud de registro de tu empresa. Recibirás un correo de verificación en tu bandeja de entrada con las instrucciones para completar la activación de tu cuenta.
                    </Typography>

                    <Button
                        variant="contained"
                        onClick={() => history.push('/login')}
                        sx={{
                            bgcolor: '#0F2350',
                            color: '#FFFFFF',
                            borderRadius: '12px',
                            px: 5,
                            py: 1.5,
                            fontSize: '15px',
                            fontWeight: 700,
                            fontFamily: FONTS_FAMILY.bold.body,
                            textTransform: 'none',
                            boxShadow: '0 4px 14px rgba(15, 35, 80, 0.2)',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                bgcolor: '#EA361A',
                                boxShadow: '0 6px 18px rgba(234, 54, 26, 0.25)'
                            }
                        }}
                    >
                        Ir a Iniciar Sesión
                    </Button>
                </Box>
            </Container>
        );
    }

    return (
        <Container ref={formTopRef}>
            {matchesWidth && (
                <Box sx={{ mb: 4, width: '100%' }}>
                    <Stepper
                        activeStep={activeStep}
                        alternativeLabel
                        sx={{
                            '& .MuiStepLabel-label': {
                                fontFamily: 'Roboto, sans-serif',
                                fontWeight: 600,
                                fontSize: '13.5px',
                                color: '#57697F',
                                mt: 1,
                                '&.Mui-active': {
                                    color: '#0F2350',
                                    fontWeight: 700
                                },
                                '&.Mui-completed': {
                                    color: '#12A3BC',
                                    fontWeight: 600
                                }
                            },
                            '& .MuiStepIcon-root': {
                                color: '#E1E9EC',
                                fontSize: '28px',
                                '&.Mui-active': {
                                    color: '#0F2350'
                                },
                                '&.Mui-completed': {
                                    color: '#12A3BC'
                                }
                            }
                        }}
                    >
                        {stepsTitles.map((label) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Box>
            )}
            <MediumHeightDivider />
            <FormModal onClose={() => setTab("1")} open={showRegisterDisclaimer} maxWidth="sm" fullWidth={true}>
                <div style={{ 
                    padding: '20px 40px', 
                    borderRadius: '20px', 
                    backgroundColor: COLORS.white,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}>
                    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
                        <div style={{ 
                            backgroundColor: COLORS.secondaryOpacity(0.1), 
                            padding: '12px', 
                            borderRadius: '50%' 
                        }}>
                            <InfoIcon style={{ color: COLORS.secondary, fontSize: '32px' }} />
                        </div>
                    </div>

                    <DisclaimerTitle style={{ 
                        textAlign: 'center', 
                        color: COLORS.secondary,
                        fontSize: '30px',
                        fontWeight: '800',
                        marginBottom: '12px'
                    }}>
                        Aviso Importante
                    </DisclaimerTitle>

                    <BodyText style={{ 
                        textAlign: 'center', 
                        marginBottom: '24px', 
                        lineHeight: '1.6',
                        color: '#475569',
                        fontSize: '15px'
                    }}>
                        Este registro es exclusivo para empresas que utilizan <strong>tramitadores</strong> o <strong>bufetes de abogados</strong>.
                        Si usted es el <strong>dueño / administrador</strong> y realizará el trámite personalmente, elija <strong>Registro ciudadano</strong>.
                    </BodyText>

                    <FormControl component="fieldset" style={{ width: '100%' }}>
                        <RadioGroup
                            aria-label="disclaimer-option"
                            name="disclaimer-option"
                            value={disclaimerOption}
                            onChange={(e) => setDisclaimerOption(e.target.value)}
                        >
                            <div style={{ 
                                border: `2px solid ${disclaimerOption === 'owner' ? COLORS.secondary : '#F1F5F9'}`,
                                borderRadius: '12px',
                                padding: '16px',
                                marginBottom: '12px',
                                backgroundColor: disclaimerOption === 'owner' ? COLORS.secondaryOpacity(0.05) : '#F8FAFC',
                                transition: 'all 0.2s ease',
                                cursor: 'pointer',
                                display: 'flex',
                                justifyContent: 'flex-start'
                            }} onClick={() => setDisclaimerOption('owner')}>
                                <FormControlLabel 
                                    value="owner" 
                                    sx={{ margin: 0, '& .MuiFormControlLabel-label': { width: '100%' } }}
                                    control={<Radio sx={{ color: COLORS.secondary, '&.Mui-checked': { color: COLORS.secondary } }} />} 
                                    label={
                                        <div style={{ textAlign: 'left' }}>
                                            <BodyText style={{ fontWeight: '600', color: COLORS.secondary }}>
                                                Soy el dueño / administrador y haré el trámite personalmente
                                            </BodyText>
                                            <BodyText style={{ fontSize: '12px', color: '#64748B', marginTop: '4px' }}>
                                                Será redirigido al Registro Ciudadano (Persona Física).
                                            </BodyText>
                                        </div>
                                    } 
                                />
                            </div>

                            <div style={{ 
                                border: `2px solid ${disclaimerOption === 'agent' ? COLORS.secondary : '#F1F5F9'}`,
                                borderRadius: '12px',
                                padding: '16px',
                                marginBottom: '24px',
                                backgroundColor: disclaimerOption === 'agent' ? COLORS.secondaryOpacity(0.05) : '#F8FAFC',
                                transition: 'all 0.2s ease',
                                cursor: 'pointer',
                                display: 'flex',
                                justifyContent: 'flex-start'
                            }} onClick={() => setDisclaimerOption('agent')}>
                                <FormControlLabel 
                                    value="agent" 
                                    sx={{ margin: 0, '& .MuiFormControlLabel-label': { width: '100%' } }}
                                    control={<Radio sx={{ color: COLORS.secondary, '&.Mui-checked': { color: COLORS.secondary } }} />} 
                                    label={
                                        <div style={{ textAlign: 'left' }}>
                                            <BodyText style={{ fontWeight: '600', color: COLORS.secondary }}>
                                                Usaré un tramitador o representante
                                            </BodyText>
                                            <BodyText style={{ fontSize: '12px', color: '#64748B', marginTop: '4px' }}>
                                                Continuará con el Registro de Empresa.
                                            </BodyText>
                                        </div>
                                    } 
                                />
                            </div>
                        </RadioGroup>
                    </FormControl>

                    <div style={{ display: 'flex', gap: '12px', marginBottom: '24px', width: '100%' }}>
                        <StyledButtonOutlined 
                            onClick={() => window.open("https://youtu.be/G518CRZZnHk?si=9nKQTUMEeTl8FF_D", "_blank")}
                            style={{ 
                                flex: 1, 
                                fontSize: '12px', 
                                padding: '8px',
                                border: `1px solid ${COLORS.secondaryOpacity(0.3)}`,
                                color: COLORS.secondary,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                justifyContent: 'center',
                                textTransform: 'none'
                            }}
                        >
                            <PlayIcon style={{ fontSize: '18px' }} /> Tutorial Empresa
                        </StyledButtonOutlined>
                        <StyledButtonOutlined 
                            onClick={() => window.open("https://youtu.be/XgmMfTBVvMY?si=YsUTZgkQaZgJKHHI", "_blank")}
                            style={{ 
                                flex: 1, 
                                fontSize: '12px', 
                                padding: '8px',
                                border: `1px solid ${COLORS.secondaryOpacity(0.3)}`,
                                color: COLORS.secondary,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px',
                                justifyContent: 'center',
                                textTransform: 'none'
                            }}
                        >
                            <PlayIcon style={{ fontSize: '18px' }} /> Tutorial Representante
                        </StyledButtonOutlined>
                    </div>

                    <StyledButton 
                        onClick={handleDisclaimerContinue}
                        fullWidth
                        style={{ 
                            backgroundColor: disclaimerOption ? COLORS.secondary : '#CBD5E1',
                            color: COLORS.white,
                            padding: '14px',
                            borderRadius: '10px',
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            letterSpacing: '1px',
                            boxShadow: disclaimerOption ? '0 10px 15px -3px rgba(32, 42, 93, 0.3)' : 'none'
                        }}
                    >
                        Completar Selección
                    </StyledButton>
                </div>
            </FormModal>
            {activeStep === 0 ? (
                <Grid
                    alignItems="center"
                    justifyContent="center"
                    container
                    direction="row"
                    spacing={{ xs: 1.2, md: 1.5 }}
                    columns={{ xs: 8, sm: 8, md: 12 }}
                >
                    <Grid item xs={12} sm={12} md={12}>
                        <TextField
                            title="Correo Electrónico"
                            type="email"
                            id="email"
                            required
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={handleBlur}
                            error={formik.touched.email && Boolean(formik.errors.email)}
                            helperText={formik.touched.email && formik.errors.email}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        <TextField
                            title="Confirmar correo electrónico"
                            type="email"
                            id="emailConfirmation"
                            required
                            value={formik.values.emailConfirmation}
                            onChange={formik.handleChange}
                            onBlur={handleBlur}
                            error={formik.touched.emailConfirmation && Boolean(formik.errors.emailConfirmation)}
                            helperText={formik.touched.emailConfirmation && formik.errors.emailConfirmation}
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        <TextField
                            title="Contraseña"
                            type={showPassword ? "text" : "password"}
                            id="password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            onBlur={handleBlur}
                            error={formik.touched.password && Boolean(formik.errors.password)}
                            helperText={formik.touched.password && formik.errors.password}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton onClick={handleClickShowPassword}>
                                        {showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            required
                        />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        <TextField
                            title="Confirmar contraseña"
                            type={showRepeatedPassword ? "text" : "password"}
                            id="password_confirmation"
                            value={formik.values.password_confirmation}
                            onChange={formik.handleChange}
                            onBlur={handleBlur}
                            error={formik.touched.password_confirmation && Boolean(formik.errors.password_confirmation)}
                            helperText={formik.touched.password_confirmation && formik.errors.password_confirmation}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton onClick={handleClickShowRepeatedPassword}>
                                        {showRepeatedPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            required
                        />
                    </Grid>
                </Grid>
            ) : activeStep === 1 ? (
                <Grid
                    alignItems="center"
                    justifyContent="flex-start"
                    container
                    direction="row"
                    spacing={{ xs: 1.2, md: 1.5 }}
                    columns={{ xs: 8, sm: 8, md: 12 }}
                >
                    <Grid item xs={8} sm={4} md={6}>
                        <TextField
                            title="RNC"
                            type="text"
                            id="citizen_id"
                            required
                            isLoading={isValidatingCedula}
                            mask={formik.values.document_type === "3" ? "999999999" : ""}
                            unMaskedValue={true}
                            value={formik.values.citizen_id}
                            onChange={(e) => {
                                setIsValidated(false);
                                formik.handleChange(e);
                            }}
                            onBlur={handleBlur}
                            error={formik.touched.citizen_id && Boolean(formik.errors.citizen_id)}
                            helperText={formik.touched.citizen_id && formik.errors.citizen_id}
                        />
                    </Grid>

                    <Grid item xs={8} sm={4} md={6}>
                        <TextField
                            title="Nombre de la empresa"
                            type="text"
                            id="name"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            onBlur={handleBlur}
                            error={formik.touched.name && Boolean(formik.errors.name)}
                            helperText={formik.touched.name && formik.errors.name}
                            required
                        />
                    </Grid>

                    <Grid item xs={8} sm={4} md={6}>
                        <PhoneTextField
                            title="Teléfono de contacto"
                            type="text"
                            id="phone"
                            required
                            value={formik.values.phone}
                            onChange={formik.handleChange}
                            onBlur={handleBlur}
                            error={formik.touched.phone && Boolean(formik.errors.phone)}
                            helperText={formik.touched.phone && formik.errors.phone}
                        />
                    </Grid>
                    <Grid item xs={8} sm={4} md={6}>
                        <TextField
                            title="Razón social"
                            type="text"
                            id="razonsocial"
                            value={formik.values.razonsocial}
                            onChange={formik.handleChange}
                            onBlur={handleBlur}
                            error={formik.touched.razonsocial && Boolean(formik.errors.razonsocial)}
                            helperText={formik.touched.razonsocial && formik.errors.razonsocial}
                            required
                        />
                    </Grid>
                    <Grid item xs={8} sm={4} md={6}>
                        <TextField
                            title="Extension"
                            type="text"
                            id="extension"
                            value={formik.values.extension}
                            onChange={formik.handleChange}
                            onBlur={handleBlur}
                            error={formik.touched.extension && Boolean(formik.errors.extension)}
                            helperText={formik.touched.extension && formik.errors.extension}
                        />
                    </Grid>
                    <Grid item xs={8} sm={4} md={12}>
                        <UploadFile
                            id="docMercantil"
                            title="Registro mercantil"
                            required
                            value={formik.values.docMercantil}
                            onBlur={handleBlur}
                            error={formik.touched.docMercantil && Boolean(formik.errors.docMercantil)}
                            onChange={formik.handleChange}
                            extension={["pdf"]}
                        />
                    </Grid>
                    
                    <Grid item xs={8} sm={4} md={12}>
                        <UploadFile
                            id="docCitizenID"
                            title="Cédula de identidad"
                            required
                            onBlur={handleBlur}
                            error={formik.touched.docCitizenID && Boolean(formik.errors.docCitizenID)}
                            value={formik.values.docCitizenID}
                            onChange={formik.handleChange}
                            extension={["pdf"]}
                        />
                    </Grid>
                    <Grid item xs={8} sm={4} md={12}>
                        <UploadFile
                            id="docNotorial"
                            title="Poder notarial que le autoriza a usted a registrar la empresa en nuestra plataforma"
                            onBlur={handleBlur}
                            error={formik.touched.docNotorial && Boolean(formik.errors.docNotorial)}
                            value={formik.values.docNotorial}
                            onChange={formik.handleChange}
                            extension={["pdf"]}
                        />
                    </Grid>
                </Grid>
            ) : activeStep === 2 ? (
                <Grid
                    alignItems="center"
                    justifyContent="center"
                    container
                    direction="row"
                    spacing={{ xs: 1.2, md: 1.5 }}
                    columns={{ xs: 8, sm: 8, md: 12 }}
                >
                    <Grid item xs={12} sm={12} md={12}>
                        <Select
                            title="Pregunta de seguridad primaria"
                            id="first_citizen_question"
                            data={questionsForShow(0)}
                            value={formik.values.first_citizen_question}
                            onChange={handleSecurityQuestionChange}
                            onBlur={handleBlur}
                            error={formik.touched.first_citizen_question && Boolean(formik.errors.first_citizen_question)}
                            helperText={formik.touched.first_citizen_question && formik.errors.first_citizen_question}
                            required
                        />
                    </Grid>

                    {Boolean(formik.values.first_citizen_question) && (
                        <Grid item xs={12} sm={12} md={12}>
                            <TextField
                                title="Respuesta de seguridad primaria"
                                type="text"
                                id="first_citizen_answer"
                                required
                                value={formik.values.first_citizen_answer}
                                onChange={formik.handleChange}
                                onBlur={handleBlur}
                                error={formik.touched.first_citizen_answer && Boolean(formik.errors.first_citizen_answer)}
                                helperText={formik.touched.first_citizen_answer && formik.errors.first_citizen_answer}
                            />
                        </Grid>
                    )}

                    <Grid item xs={12} sm={12} md={12}>
                        <Select
                            title="Pregunta de seguridad secundaria"
                            id="second_citizen_question"
                            data={questionsForShow(1)}
                            value={formik.values.second_citizen_question}
                            onChange={handleSecurityQuestionChange}
                            onBlur={handleBlur}
                            error={formik.touched.second_citizen_question && Boolean(formik.errors.second_citizen_question)}
                            helperText={formik.touched.second_citizen_question && formik.errors.second_citizen_question}
                            required
                        />
                    </Grid>

                    {Boolean(formik.values.second_citizen_question) && (
                        <Grid item xs={12} sm={12} md={12}>
                            <TextField
                                title="Respuesta de seguridad secundaria"
                                type="text"
                                id="second_citizen_answer"
                                required
                                value={formik.values.second_citizen_answer}
                                onChange={formik.handleChange}
                                onBlur={handleBlur}
                                error={formik.touched.second_citizen_answer && Boolean(formik.errors.second_citizen_answer)}
                                helperText={formik.touched.second_citizen_answer && formik.errors.second_citizen_answer}
                            />
                        </Grid>
                    )}

                    <Grid item xs={12} sm={12} md={12}>
                        <Select
                            title="Pregunta de seguridad terciaria"
                            id="third_citizen_question"
                            data={questionsForShow(2)}
                            value={formik.values.third_citizen_question}
                            onChange={handleSecurityQuestionChange}
                            onBlur={handleBlur}
                            error={formik.touched.third_citizen_question && Boolean(formik.errors.third_citizen_question)}
                            helperText={formik.touched.third_citizen_question && formik.errors.third_citizen_question}
                            required
                        />
                    </Grid>

                    {Boolean(formik.values.third_citizen_question) && (
                        <Grid item xs={12} sm={12} md={12}>
                            <TextField
                                title="Respuesta de seguridad terciaria"
                                type="text"
                                id="third_citizen_answer"
                                required
                                value={formik.values.third_citizen_answer}
                                onChange={formik.handleChange}
                                onBlur={handleBlur}
                                error={formik.touched.third_citizen_answer && Boolean(formik.errors.third_citizen_answer)}
                                helperText={formik.touched.third_citizen_answer && formik.errors.third_citizen_answer}
                            />
                        </Grid>
                    )}
                </Grid>
            ) : activeStep === 3 ? (
                <Fragment>
                    <Box 
                        sx={{ 
                            maxHeight: '340px', 
                            overflowY: 'auto', 
                            p: { xs: 2, sm: 3 }, 
                            backgroundColor: '#FFFFFF', 
                            borderRadius: '16px', 
                            border: '1px solid #E1E9EC',
                            mb: 2,
                            boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.02)',
                            '&::-webkit-scrollbar': {
                                width: '6px'
                            },
                            '&::-webkit-scrollbar-thumb': {
                                backgroundColor: '#CFDCE0',
                                borderRadius: '4px'
                            }
                        }}
                    >
                        <WpRichTextContainer>{wordpressContent && parse(wordpressContent)}</WpRichTextContainer>
                        <SmallHeightDivider />
                        <Box sx={{ pt: 2, borderTop: '1px solid #E1E9EC' }}>
                            <CheckBox
                                id="termsAndCondition"
                                onChange={formik.handleChange}
                                onBlur={handleBlur}
                                error={formik.touched.termsAndCondition && Boolean(formik.errors.termsAndCondition)}
                                helperText={formik.touched.termsAndCondition && formik.errors.termsAndCondition}
                                value={formik.values.termsAndCondition}
                                label="Acepto los terminos y condiciones de uso y privacidad"
                            />
                        </Box>
                    </Box>
                </Fragment>
            ) : null}

            <ButtonsContainer style={{ marginTop: '24px' }}>
                <ButtonContainer>
                    <Button
                        variant="contained"
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        sx={{
                            bgcolor: activeStep === 0 ? '#E1E9EC' : '#0F2350',
                            color: activeStep === 0 ? '#A0AEC0' : '#FFFFFF',
                            borderRadius: '12px',
                            px: 3,
                            py: 1.2,
                            textTransform: 'none',
                            fontWeight: 700,
                            fontFamily: 'Roboto, sans-serif',
                            boxShadow: activeStep === 0 ? 'none' : '0 4px 14px rgba(15, 35, 80, 0.2)',
                            '&:hover': {
                                bgcolor: activeStep === 0 ? '#E1E9EC' : '#EA361A'
                            }
                        }}
                    >
                        Retroceder
                    </Button>
                </ButtonContainer>

                {!matchesWidth && <MobileStepper variant="dots" steps={stepsLenght} position="static" activeStep={activeStep} />}

                <ButtonContainer style={{ textAlign: 'right' }}>
                    <Button
                        variant="contained"
                        disabled={lastStep && !formik.values.termsAndCondition}
                        onClick={handleSubmitForm}
                        sx={{
                            bgcolor: (lastStep && !formik.values.termsAndCondition) ? '#E1E9EC' : '#0F2350',
                            color: (lastStep && !formik.values.termsAndCondition) ? '#A0AEC0' : '#FFFFFF',
                            borderRadius: '12px',
                            px: 4,
                            py: 1.2,
                            textTransform: 'none',
                            fontWeight: 700,
                            fontSize: '15px',
                            fontFamily: 'Roboto, sans-serif',
                            boxShadow: (lastStep && !formik.values.termsAndCondition) ? 'none' : '0 4px 14px rgba(15, 35, 80, 0.25)',
                            '&:hover': {
                                bgcolor: (lastStep && !formik.values.termsAndCondition) ? '#E1E9EC' : '#EA361A'
                            }
                        }}
                    >
                        {lastStep ? "Registrar" : "Continuar"}
                    </Button>
                </ButtonContainer>
            </ButtonsContainer>
        </Container>
    );
}
